import sanityClient from "./sanityClient"; // Adjust the path to your Sanity client

const fetchContactUs = async () => {
  try {
    const query = `*[_type == "contactUs"][0]{
      title,
      image,
      content
    }`;

    const data = await sanityClient.fetch(query);


    return data;
  } catch (error) {
    console.error("Error fetching contact data:", error);
    return null;
  }
};

export default fetchContactUs;